module.exports = __webpack_public_path__ + "img/side-purchase.25fa1eca.svg";